import * as ambassadorWixCloudDataUsageV1SiteDataUsage from './cloud-data-usage-v1-site-data-usage-data.http.js';
import * as ambassadorWixCloudDataUsageV1SiteDataUsageTypes from './cloud-data-usage-v1-site-data-usage-data.types.js';
import * as ambassadorWixCloudDataUsageV1SiteDataUsageUniversalTypes from './cloud-data-usage-v1-site-data-usage-data.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSiteDataUsage(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixCloudDataUsageV1SiteDataUsageUniversalTypes.GetSiteDataUsageRequest,
  ambassadorWixCloudDataUsageV1SiteDataUsageTypes.GetSiteDataUsageRequest,
  ambassadorWixCloudDataUsageV1SiteDataUsageUniversalTypes.GetSiteDataUsageResponse,
  ambassadorWixCloudDataUsageV1SiteDataUsageTypes.GetSiteDataUsageResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCloudDataUsageV1SiteDataUsage.getSiteDataUsage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/site-data-usage',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SiteDataUsage as SiteDataUsageOriginal,
  Usage as UsageOriginal,
  DataCollectionUsage as DataCollectionUsageOriginal,
  CollectionType as CollectionTypeOriginal,
  CollectionTypeWithLiterals as CollectionTypeWithLiteralsOriginal,
  GetSiteDataUsageRequest as GetSiteDataUsageRequestOriginal,
  GetSiteDataUsageResponse as GetSiteDataUsageResponseOriginal,
  BulkUpdateUsagesRequest as BulkUpdateUsagesRequestOriginal,
  DataCollectionUsageUpdate as DataCollectionUsageUpdateOriginal,
  Segment as SegmentOriginal,
  SegmentWithLiterals as SegmentWithLiteralsOriginal,
  InstanceUsageUpdate as InstanceUsageUpdateOriginal,
  BulkUpdateUsagesResponse as BulkUpdateUsagesResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  DataChangeEvent as DataChangeEventOriginal,
  DataChangeEventEventOneOf as DataChangeEventEventOneOfOriginal,
  DataChanged as DataChangedOriginal,
  DataChangedChangeOneOf as DataChangedChangeOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  DataStore as DataStoreOriginal,
  DataStoreWithLiterals as DataStoreWithLiteralsOriginal,
  Initiator as InitiatorOriginal,
  Identity as IdentityOriginal,
  Enrichment as EnrichmentOriginal,
  ChangesLost as ChangesLostOriginal,
  ReferenceChanged as ReferenceChangedOriginal,
  SegmentChanged as SegmentChangedOriginal,
  SegmentMigrationStarted as SegmentMigrationStartedOriginal,
  IgnoredSourceEvent as IgnoredSourceEventOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './cloud-data-usage-v1-site-data-usage-data.types.js';
